module.exports = __webpack_public_path__ + "static/karma_icon-98a929adb647f38c357624f1f90c083f.svg";